import React, { useEffect, useRef, useState } from "react";
import {
  Alert,
  Button,
  Drawer,
  Field,
  Icon,
  useToast,
} from "../../../design-system";
import { fulfillDocumentRequest } from "../../../helpers/documents_helper";
import { FileDropInput } from "./FileDropInput";

export function FulfillRequestDrawer({ request, onClose, onFulfilled }) {
  const toast = useToast();
  const fileRef = useRef(null);
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const open = !!request;

  useEffect(() => {
    if (!open) {
      setFile(null);
      setError(null);
      if (fileRef.current) fileRef.current.value = "";
    }
  }, [open]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (!file) {
      setError("Selecciona un archivo.");
      return;
    }
    setSubmitting(true);
    try {
      await fulfillDocumentRequest(request.id, file);
      toast.success("Documento subido");
      onFulfilled?.();
    } catch (e2) {
      setError(typeof e2 === "string" ? e2 : e2?.message || "No se pudo subir el documento.");
    } finally {
      setSubmitting(false);
    }
  };

  const formId = "fulfill-request-form";

  return (
    <Drawer
      open={open}
      onClose={submitting ? undefined : onClose}
      title="Subir documento solicitado"
      size="md"
      footer={
        request ? (
          <>
            <Button variant="ghost" type="button" onClick={onClose} disabled={submitting}>Cancelar</Button>
            <div style={{ flex: 1 }} />
            <Button variant="primary" type="submit" form={formId} icon="Upload" disabled={submitting}>
              {submitting ? "Subiendo…" : "Subir documento"}
            </Button>
          </>
        ) : null
      }
    >
      {request && (
        <form id={formId} onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {error && <Alert tone="danger">{error}</Alert>}

          <div
            style={{
              background: "var(--kr-bg-subtle)",
              border: "1px solid var(--kr-border-subtle)",
              borderRadius: 8,
              padding: 14,
              display: "flex",
              flexDirection: "column",
              gap: 8,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Icon name="Inbox" size={14} style={{ color: "var(--kr-warning-700)" }} />
              <span style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.04em", color: "var(--kr-fg-muted)", fontWeight: 600 }}>
                Solicitud
              </span>
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, color: "var(--kr-fg-strong)" }}>
              {request.title}
            </div>
            <div style={{ fontSize: 12, color: "var(--kr-fg-muted)" }}>
              {request.category?.parent_name
                ? `${request.category.parent_name} › ${request.category.name}`
                : request.category?.name}
            </div>
            {request.message && (
              <div style={{ fontSize: 13, color: "var(--kr-fg-strong)", lineHeight: 1.45, marginTop: 4 }}>
                {request.message}
              </div>
            )}
          </div>

          <Field label="Archivo" required>
            <FileDropInput
              file={file}
              inputRef={fileRef}
              onFileChange={(e) => setFile(e.target.files?.[0] || null)}
            />
          </Field>
        </form>
      )}
    </Drawer>
  );
}
